import React from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function PfumaClaims(props) {

    const classes = useStyles();

    return (
        <div>
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/claims"><a href><i className="fa-solid fa-basket-shopping"/>&nbsp;Claims</a>
                            </Link>
                             &nbsp;|&nbsp;
                            <span className="upper-class">Pfuma / Inotho Claims</span>
                        </ul>
                        <div className="row mt">
                            <div className="col-lg-12">

                                <div className={classes.root}>
                                    <section className="py-1">
                                        <div className="container mt-1">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="row mt-5 container mb-5">
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-hospital'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-house-medical-flag fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Hospital Cash</h6>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-accident'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-person-falling-burst fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Personal
                                                                        Accident</h6>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-funeral'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-truck-medical fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Funeral</h6>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-deaths'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-bed-pulse fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Death Claims</h6>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-refunds'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-rotate-left fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Refunds</h6>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-withdrawals'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-money-bill-transfer fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Partial
                                                                        Withdrawals</h6>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-surrenders'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-power-off fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Surrenders</h6>
                                                                </div>
                                                            </a>
                                                        </div>
                                                        <div className="col-lg-4 col-md-6 col-sm-12 mb-5 mt-md-5">
                                                            <a href={'/inotho-maturity'}>
                                                                <div className="move-on-hover">
                                                                    <i className="fa-solid fa-chart-simple fa-3x"></i>
                                                                </div>
                                                                <div className="mt-2 ms-2">
                                                                    <h6 className="mb-0">Pfuma / Inotho Maturity</h6>
                                                                </div>
                                                            </a>
                                                        </div>

                                                    </div>
                                                    <hr/>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default PfumaClaims;
